module.exports = __webpack_public_path__ + "img/shopping-setup-level1.5df2e061.png";